import {
  Box,
  Button,
  ButtonGroup,
  HStack,
  IconButton,
  Stack,
  Text,
  Tag,
  VStack,
  Center,
  AlertDialogBody,
  AlertDialogHeader,
} from "@chakra-ui/react";
import JsonRender from "../../../../renderer/JsonRender";
import Images from "../../components/Images";
import { assets } from "../../../../assets";
import Loader from "../../../../components/Loader";
import {
  initalLesson,
  updateLessonState,
} from "../../../../store/slices/lessonSlice";
import { DeleteIcon } from "@chakra-ui/icons";
import Dialog from "../../../../components/Dialogs/Dialog";
import { Role } from "../../../../Providers/AuthProvider";
import AddPlugin from "../../components/AddPlugin";
import { useLessonState } from "./useState";
import MobileIcon from "../../../../assets/icons/Mobile";
import EditPluginPropsChange from "../../components/EditPluginProps.";

const Lesson = () => {
  const { state, handlers, panels } = useLessonState();
  const { mainPanel, alternatePannel } = panels;
  const {
    isImageDrawerOpen,
    isPluginDrawerOpen,
    role,
    generateLesson,
    removeLesson,
    courseId,
    dialog,
    rightPanel,
    allLessons,
    modules,
    currentLesson,
    isMobileView,
    openPluginPropsChange,
    currentContentId,
  } = state;
  const {
    handleLessonRemove,
    setDialog,
    navigate,
    handlePluginSelect,
    handleContentClick,
    dispach,
    setIsImageDrawerOpen,
    setIsPluginDrawerOpen,
    setIsPluginPropsChange,
    handleMobileView,
  } = handlers;
  return (
    <Box>
      <Box
        width={"full"}
        bg={"background"}
        position={"sticky"}
        top={0}
        zIndex={"1000"}
        display={"flex"}
        justifyContent={"center"}
        px={"2rem"}
        py={"1rem"}
      >
        <HStack>
          <Text>{modules?.data?.title}</Text>
          <Box>
            <IconButton
              onClick={handleMobileView}
              aria-label="mobile icon"
              variant={isMobileView ? "solid" : "outline"}
            >
              <MobileIcon />
            </IconButton>
          </Box>
        </HStack>
      </Box>

      {modules.isLoading ? (
        <Loader />
      ) : generateLesson.isPending ? (
        <Center>
          <VStack mt={"10%"}>
            <Box sx={{ zoom: "2.7" }}>
              <Loader />
            </Box>
            <Text fontSize={"xl"}>Lesson Generating...</Text>
          </VStack>
        </Center>
      ) : (
        <Center>
          <Box w={isMobileView ? "22rem" : "30rem"}>
            <JsonRender
              mode={"edit"}
              lessonId=""
              onClick={handleContentClick}
              content={currentLesson.content}
            />
          </Box>
        </Center>
      )}

      <Box
        width={"sm"}
        bg={"neutral.950"}
        p={"1rem"}
        zIndex={"sticky"}
        position={"fixed"}
        h={"100vh"}
        overflowY={"auto"}
        top={0}
        left={0}
      >
        <Box>
          <Box mb={"1rem"}>
            <HStack>
              <IconButton
                aria-label="close lesson"
                border={"1px solid white"}
                borderRadius={".9rem"}
                variant={"outline"}
                size={"md"}
                onClick={() =>
                  navigate(`/dashboard/internal/courses/modules/${courseId}`)
                }
                icon={assets.iconComponents.backIcon()}
              ></IconButton>
              <ButtonGroup>
                <Button
                  variant={"outline"}
                  onClick={() => setIsImageDrawerOpen(true)}
                >
                  Images
                </Button>
              </ButtonGroup>
            </HStack>
          </Box>
          <Box>
            <VStack gap={".4rem"}>
              {allLessons.length === 0 && <Text>No Lessons added yet</Text>}
              {allLessons.map((les: any) => (
                <HStack
                  bg={
                    currentLesson._id === les._id ? "blue.500" : "neutral.900"
                  }
                  cursor={"pointer"}
                  width={"full"}
                  p={".5rem"}
                  borderRadius={".3rem"}
                  justifyContent={"space-between"}
                  onClick={() => {
                    dispach(updateLessonState({ currentLesson: les }));
                  }}
                >
                  <Text>
                    {les._id === currentLesson._id
                      ? currentLesson.title
                      : les.title}
                  </Text>
                  <HStack>
                    <Tag variant={"outline"}>{les.type}</Tag>
                    <Tag>{les.status}</Tag>
                    {(role === Role.SuperAdmin || role === Role.Admin) && (
                      <IconButton
                        variant={"solid"}
                        colorScheme="red"
                        size={"sm"}
                        aria-label="delete lesson"
                        onClick={() => setDialog("remove")}
                      >
                        <DeleteIcon fontSize={"sm"} />
                      </IconButton>
                    )}
                  </HStack>
                </HStack>
              ))}
              <Button
                onClick={() => {
                  dispach(updateLessonState({ currentLesson: initalLesson }));
                }}
                variant={"secondary"}
                width={"full"}
              >
                New Lesson
              </Button>
            </VStack>
          </Box>
        </Box>
      </Box>

      <Images
        isOpen={isImageDrawerOpen}
        onClose={() => setIsImageDrawerOpen(false)}
        editMode={true}
      />

      <Box>
        <AddPlugin
          isOpen={isPluginDrawerOpen}
          onClose={() => setIsPluginDrawerOpen(false)}
          onPluginSelect={handlePluginSelect}
        />
      </Box>
      <EditPluginPropsChange
        isOpen={openPluginPropsChange}
        currentContentId={currentContentId}
        onClose={() => setIsPluginPropsChange(false)}
        onClick={() => {}}
      />

      <Box
        width={"md"}
        bg={"neutral.950"}
        p={"1rem"}
        zIndex={"sticky"}
        position={"fixed"}
        h={"100vh"}
        overflowY={"auto"}
        top={0}
        right={0}
      >
        {rightPanel === "alternate" && alternatePannel}
        {rightPanel === "main" && mainPanel}
      </Box>
      <Dialog isOpen={!!dialog} onClose={() => setDialog(null)}>
        <AlertDialogHeader>Are you want Remove this lesson?</AlertDialogHeader>
        <AlertDialogBody>
          <Stack gap={"1rem"}>
            <Text>{currentLesson.title}</Text>
            <ButtonGroup ms="auto">
              <Button
                isDisabled={removeLesson.isPending}
                variant={"outline"}
                onClick={() => setDialog(null)}
              >
                Cancel
              </Button>

              <Button
                onClick={handleLessonRemove}
                isLoading={removeLesson.isPending}
                variant={"solid"}
                colorScheme="red"
              >
                Remove
              </Button>
            </ButtonGroup>
          </Stack>
        </AlertDialogBody>
      </Dialog>
    </Box>
  );
};

export default Lesson;
